export default {
  title: "Services",
  laundry: {
    title: "Laundry Service",
    free: "Free",
    washing_machine: "Washing Machine",
    dryer: "Dryer",
    per_cycle: "/ cycle",
    pay_and_start: "Pay & Start",
    in_use: "In Use",
    location: "Laundry room located on Floor 1, Room 105"
  },
  reductions: {
    title: "Active discounts",
    subtitle: "Save more on your booking with these offers",
    valid_until: "Valid until",
    auto_apply: "Auto applied",
    note: "These are currently active discounts. Extra booking conditions may still apply.",
    expiring_soon: "Expiring soon",
    valid_for_buildings: "Valid for:",
    valid_for_all_buildings: "Valid for all buildings",
    max_occupancy: "Max guests:",
    selected_unit_types: "Only valid for selected room types",
    stay: "Stay:",
    stay_from: "Stay from",
    days: "days",
    travel_dates: "Travel dates:",
    travel_from: "Travel from:",
    travel_until: "Travel until:",
    use_once_per_guest: "Can be used once per guest",
    use_up_to: "Can be used up to",
    times_per_guest: "times per guest",
    manual_code: "Promo code may need to be entered manually",
    description_percentage: "Percentage discount",
    description_fixed_amount: "Fixed amount discount",
    description_free_night: "Free night offer",
    description_free_nights: "Free night offer",
    description_free_option: "Free option offer",
    description_default: "Discount",
    available_count: "promotions available",
    code_copied: "Promo code copied",
    code_copy_failed: "Could not copy promo code",
    tap_to_copy: "Tap a promo card to copy the code",
    book_now: "Book now",
    view_buildings: "View buildings"
  },
  extras: {
    title: "Enhance Your Stay",
    add: "Add"
  },
  cleaning: {
    title: "Cleaning services",
    intro: "Reserve cleaning equipment and pick it up at reception before cleaning your studio.",
    pickup: "Pick up at reception",
    reserve: "Reserve",
    free: "Free",
    kit_note: "Prefer your own supplies? Cleaning kits are also available for purchase at reception."
  },
  faq: {
    title: "FAQs",
    search_label: "Search questions...",
    no_results: "No FAQs match your search.",
    select_building: "Select your building",
    select_building_first: "Select a building to view the frequently asked questions."
  },
  support: {
    title: "Support",
    sales: {
      title: "Call sales",
      subtitle: "Available now: "
    },
    call: {
      title: "Call resident manager",
      subtitle: "{phone}"
    },
    chat: {
      title: "Live Chat",
      subtitle: "Quick response"
    },
    directions: {
      title: "Get Directions",
      subtitle: "Navigate to hotel",
      url: "https://maps.google.com"
    },
    emergency: {
      title: "Emergency Contact",
      subtitle: "Only call in case of emergency."
    }
  }
};
